import classnames from "classnames";
import React from "react";
import styles from "./ProgressBar.module.scss";

interface ProgressBarProps {
  totalProgress: number;
  correctAnswers: number;
  incorrectAnswers: number;
}

const ProgressBar: React.FC<ProgressBarProps> = (props) => {
  return (
    <div className={styles.progressBar}>
      <div className={classnames(styles.value, { [styles.completed]: props.correctAnswers === 100 })}>
        {props.totalProgress} %
      </div>
      <div className={styles.bar}>
        <div className={styles.correct} style={{ width: `${props.correctAnswers}%` }} />
        <div className={styles.incorrect} style={{ width: `${props.incorrectAnswers}%` }} />
      </div>
    </div>
  );
};

export default ProgressBar;
